const yup = require("yup");

const deleteRecord = yup.object({
  deleteRecord: yup.string().required("Delete is required"),
});

const CreateSetRegistraion = yup.object({
  start: yup.date().required("Start date is required"),
  late: yup.date().required("Last date is required").min(yup.ref("start"), "End date must be after the start date"),
  end: yup.date().required("End Date name a required fields"),
  hodapproval: yup.boolean().required("HOD Approval is a required fields"),
});

module.exports = {
  CreateSetRegistraion,
  deleteRecord,
};
